import { AnalyzerConnection, Repository } from '@/types/types'

export const WIDGET_ICON_MAP = {
  'ddp-widget': 'external-dependencies',
  'idp-widget': 'indirect-dependency',
  'lcv-widget': 'line-coverage',
  'bcv-widget': 'z-git-branch',
  'dcv-widget': 'documentation-coverage',
  'secrets-widget': 'secret',
  'bug-risk-widget': 'bug-risk',
  'antipattern-widget': 'antipattern',
  'style-widget': 'style',
  'security-widget': 'security',
  'performance-widget': 'performance',
  'doc-widget': 'doc',
  'typecheck-widget': 'typecheck',
  'coverage-widget': 'coverage',
  'ccv-widget': 'condition-coverage',
  'cpcv-widget': 'composite-coverage'
} as const

export type WidgetKey = keyof typeof WIDGET_ICON_MAP
export type WidgetIcon = (typeof WIDGET_ICON_MAP)[WidgetKey]

export function getRepoCardProps({
  supportedAnalyzers,
  availableAnalyzers,
  isStarred,
  id,
  name,
  displayName,
  vcsProvider,
  ownerLogin,
  isPrivate,
  latestCommitOid,
  defaultBranchName,
  lastAnalyzedAt,
  kind,
  createdAt
}: Repository) {
  return {
    supportedAnalyzers,
    availableAnalyzers,
    isStarred,
    id,
    name,
    displayName,
    vcsProvider,
    ownerLogin,
    isPrivate,
    latestCommitOid,
    defaultBranchName,
    lastAnalyzedAt,
    kind,
    createdAt
  } as {
    supportedAnalyzers: string[]
    availableAnalyzers: AnalyzerConnection
    isStarred: boolean
    id: string
    name: string
    displayName: string
    vcsProvider: string
    ownerLogin: string
    isPrivate: boolean
    latestCommitOid: string
    defaultBranchName: string
    lastAnalyzedAt: string
    kind: string
    createdAt: string
  }
}
